
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EditFrame from "../EditFrame.vue";
@Component({
  components: { EditFrame },
})
export default class DeviceDescription extends Vue {
  @Prop() description!: string;
  @Prop({ default: false }) editMode!: boolean;
  editedDescription: string | null = null;
  mounted(): void {
    this.importData();
  }
  @Watch("description")
  onDescriptionChanged(): void {
    this.importData();
  }
  importData(): void {
    this.editedDescription = this.description;
  }
  getValue(): string | null {
    return this.editedDescription;
  }

  onInput(value: string): void {
    this.editedDescription = value;
    this.$emit("input", value);
  }
}
